module.exports = __webpack_public_path__ + "static/media/favicon-192x192.9aaf198b.png";